import React, { useEffect, useState } from "react";

import { TableBody } from "@material-ui/core";
import { startCase } from "lodash";

import { TableCard } from "@hubcapp/components";
import { formatCurrency } from "@ds-developer/frontend";

import { Allocation, LearnerLessonType } from "@hubcapp/types";
import { LessonDetailsProps } from "./types";
import { productCategoryTypeToCategoryTitle } from "@hubcapp/utils";
import DetailsRow from "./components/DetailsRow";
import UpdateHourlyRateModal from "@hubcapp/components/Modals/UpdateHourlyRateModal";
import pluralize from "pluralize";

const LessonDetails: React.FC<LessonDetailsProps> = ({
  loading = false,
  allocations,
  name,
  lessonBalances = [],
  pickupAddress,
}) => {
  const [hourlyRateModalIsOpen, setHourlyRateModalIsOpen] = useState<boolean>(
    false,
  );

  const [currentAllocation, setCurrentAllocation] = useState<Allocation | null>(
    null,
  );

  useEffect(() => {
    if (allocations && allocations[0]) {
      setCurrentAllocation(allocations[0]);
    }
  }, [allocations]);

  return (
    <TableCard loading={loading} title="Lesson details">
      <TableBody>
        <DetailsRow title="Type">
          {allocations?.map(({ learnerLessonType, id }, idx) => (
            <span key={id} data-test="learner-details-type">
              {startCase(learnerLessonType)}
              {idx + 1 !== allocations.length && ", "}
            </span>
          ))}
        </DetailsRow>

        {allocations
          ?.filter(({ purchaseRate, purchaseVatRate }) =>
            Boolean((purchaseRate || 0) * ((purchaseVatRate || 0) + 1)),
          )
          .map(allocation => {
            const {
              purchaseRate,
              purchaseVatRate,
              id,
              learnerLessonType,
            } = allocation;
            return (
              <DetailsRow
                key={id}
                title="Rate"
                text="Edit"
                action={
                  learnerLessonType === LearnerLessonType.Motability ||
                  learnerLessonType === LearnerLessonType.Dit
                    ? undefined
                    : () => {
                        setCurrentAllocation(allocation);
                        setHourlyRateModalIsOpen(true);
                      }
                }
              >
                <span data-test="learner-details-rate">
                  {purchaseRate &&
                    formatCurrency(
                      (purchaseRate || 0) * ((purchaseVatRate || 0) + 1),
                    )}
                </span>
              </DetailsRow>
            );
          })}
        <UpdateHourlyRateModal
          fullName={`${name?.firstName || ""} ${name?.lastName || ""}`}
          handleClose={() => setHourlyRateModalIsOpen(false)}
          open={hourlyRateModalIsOpen}
          postcode={pickupAddress?.postcode}
          allocation={currentAllocation}
        />

        {lessonBalances.map((lessonBalanceWithCategory, idx) => (
          <DetailsRow
            key={idx}
            title={`${productCategoryTypeToCategoryTitle(
              lessonBalanceWithCategory.category,
              { fullDitName: true },
            )} balance`}
          >
            {`${lessonBalanceWithCategory.hours || 0} ${pluralize(
              "hours",
              lessonBalanceWithCategory.hours || 0,
            )}`}
          </DetailsRow>
        ))}
      </TableBody>
    </TableCard>
  );
};

export default LessonDetails;
